<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        Upload SKU
      </div>
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>
    <v-card>
      <v-card-title>
        <span class="body-1 font-weight-bold"
          >SKU

          <i class="caption red--text ml-4"> * required field</i>
        </span>
      </v-card-title>
      <!-- <v-divider></v-divider>
      <v-card-text>
        <v-form>
          <ul class="text-left mb-2">
            <li>Customer Reference Number has to be unique</li>
          </ul>
        </v-form>
      </v-card-text> -->
      <v-divider class="mb-3"></v-divider>
      <v-card-text>
        <v-form ref="form">
          <div class="text-center py-0">
            <v-row no-gutters>
              <v-col
                md="6"
                v-if="
                  userCategory.user_category === 3 ||
                  userCategory.user_category === 6
                "
                class="pl-3"
              >
                <v-autocomplete
                  v-model="selectedClient"
                  :items="clients"
                  :loading="clientLoader"
                  hide-no-data
                  item-text="name"
                  item-value="id"
                  label="Select Client"
                  placeholder="Start typing to Search"
                  class="pb-2 pt-0 text-center required"
                  :rules="[(v) => !!v || 'Please Select Client']"
                  @focus="fetchClientList"
                  outlined
                  @change="getwarehouse(selectedClient)"
                ></v-autocomplete>
              </v-col>
              <v-col md="6" class="pl-3">
                <v-autocomplete
                  v-model="warehouse"
                  :items="warehouses"
                  item-text="name"
                  item-value="id"
                  label="Select Warehouse"
                  placeholder="Start typing to Search"
                  class="pb-2 pt-0 text-center required"
                  :rules="[(v) => !!v || 'Please Select Warehouse']"
                  outlined
                  @change="getStores(selectedClient, warehouse)"
                ></v-autocomplete>
              </v-col>
              <v-col md="6" class="pb-0 pl-3">
                <v-autocomplete
                  v-model="infor_storer_id"
                  label="Storer Name"
                  :rules="[(v) => !!v || 'Storer Name is required.']"
                  item-text="channel_name"
                  item-value="id"
                  class="required"
                  :items="stores"
                  outlined
                ></v-autocomplete>
              </v-col>

              <v-col md="6" class="custom">
                <v-file-input
                  v-model="file"
                  counter
                  show-size
                  accept=".xlsx"
                  class="required pl-3"
                  label="Select your File"
                  outlined
                  prepend-icon=""
                  prepend-inner-icon="mdi-paperclip"
                  :rules="[(v) => !!v || 'Please Select File']"
                  @click="file = null"
                >
                </v-file-input>
              </v-col>
            </v-row>
            <v-row class="text-left mt-0 pt-0">
              <v-col class="pl-6 pt-0">
                <!-- <v-btn color="green" dark class="mr-3" @click="listPage">
                  List
                </v-btn> -->
                <v-btn
                  color="primary"
                  dark
                  :loading="fileLoader"
                  @click="upload"
                >
                  Upload
                </v-btn>
                <v-btn
                  color="info"
                  class="ml-3"
                  :loading="downloader"
                  @click="downloadTemplate()"
                  >Download template</v-btn
                >

                <v-btn class="ml-3" @click="close()"> Cancel </v-btn>
              </v-col>
            </v-row>
          </div>
        </v-form>
      </v-card-text>
    </v-card>
  </v-col>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  components: {},
  computed: {
    ...mapGetters(["userRole", "userCategory"]),
    getStartDate() {
      var startDate = new Date();
      startDate.setDate(startDate.getDate() + 1);
      startDate.setHours(0, 0, 0, 0);
      return startDate.toISOString().split("T")[0];
    },
  },
  created() {
    if (this.userCategory.user_category === 1) {
      this.selectedClient = this.$store.getters.user.id;
      this.getInboundSettings(this.$store.getters.user.id).then((response) => {
        this.newTemplate = response.data.add_sku;
      });
      this.getInforWarehouseListBB(this.$store.getters.user.id).then(
        (response) => {
          this.warehouses = response.data.result;
        }
      );
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.fetchClientList();
    });
  },
  data() {
    return {
      date: null,
      dateMenu: false,
      clients: [],
      selectedClient: null,
      total: 0,
      file: null,
      fileLoader: false,
      dialog: false,
      statusType: null,
      downloader: false,
      uploadRes: {},
      clientLoader: false,
      warehouses: [],
      receipt_no: "",
      warehouse: "",
      infor_storer_id: null,
      stores: [],
      expected_receipt_date: null,
      dateMenuExpected: false,
      newTemplate: null,
    };
  },

  methods: {
    ...mapActions([
      "downloadSkuBBTemplate",

      "fetchClient",
      "snackBar",
      "getInforWarehouseListBB",
      "getWarehouseStores",
      "getInboundSettings",
      "uploadb2bskuList",
    ]),
    getwarehouse(id) {
      this.warehouse = "";
      this.infor_storer_id = null;
      this.getInforWarehouseListBB(id).then((response) => {
        this.warehouses = response.data.result;
      });
    },
    downloadTemplate() {
      this.downloader = true;
      let url =
        "/api/file_download?file_path=fulfillmentb2b/b2b_sku_upload.xlsx";
      this.downloadSkuBBTemplate(url)
        .then((res) => {
          this.fileDownload(res);
          this.downloader = false;
        })
        .catch(() => {
          this.downloader = false;
        });
    },

    upload() {
      if (!this.$refs.form.validate()) return;
      this.fileLoader = true;
      const payload = new FormData();
      payload.append("data_file", this.file, this.file.name);
      if (
        this.userCategory.user_category === 3 ||
        this.userCategory.user_category === 6
      ) {
        payload.append("client_id", this.selectedClient);
      }
      payload.append("warehouse_id", this.warehouse);
      payload.append("storer_id", this.infor_storer_id);
      this.uploadb2bskuList(payload)
        .then((res) => {
          this.fileLoader = false;
          this.snackBar({
            color: "success",
            message: res.data.message,
          });

          this.$refs.form.reset();
          this.date = null;
          this.$router.push("/sku-b2b-list");
        })
        .catch(() => {
          this.fileLoader = false;
        });
    },
    close() {
      this.selectedClient = null;
      this.file = null;
      this.fileLoader = false;
      this.$refs.form?.reset();
      this.date = null;
      this.$router.push("/sku-b2b-list");
    },
    fetchClientList() {
      if (this.clients.length) return;

      if (
        this.clients.length === 0 &&
        (this.userCategory.user_category === 3 ||
          this.userCategory.user_category === 6)
      ) {
        this.clientLoader = true;

        this.fetchClient({
          fields: "id,name",
          pagination: 0,
          service: "b2b_fulfillment",
          active_facility: 1,
        })
          .then((res) => {
            this.clientLoader = false;
            this.clients = res.data;
          })
          .catch(() => {
            this.clientLoader = false;
          });
      }
    },
    getStores(client, id) {
      let payload = {
        client_id: client,
        warehouse_id: id,
      };

      this.getWarehouseStores(payload).then((res) => {
        this.stores = res.data;
      });
    },
    listPage() {
      this.$router.push({
        name: "skuBBStatusList",
        params: {
          type: "b2b_sku_upload",
        },
      });
    },
  },
};
</script>
<style>
.custom .v-text-field {
  padding-top: 0;
}
</style>
